<div ngbDropdown id="action-open-menu" container="body">
  <button class="btn p-0 no-dropdown-toggle-icon" type="button" ngbDropdownToggle>
    <i class="icon-lg pb-3px" [data-feather]="icon" appFeatherIcon></i>
  </button>
  <div ngbDropdownMenu class="dropdown-menu-left">
    <div *ngFor="let action of actions">
      <div *ngIf="action.divider" class="dropdown-divider"></div>
      <a *ngIf="hideCustomActionItem(action.hide, action.showWhen, item, action.visible)"
        (click)="onActionClick(action, item, $event)"
        [id]="action.id"
        [class.disabled]="isActionDisabled(action, item)"
        [attr.aria-disabled]="isActionDisabled(action, item)"
        ngbDropdownItem>
        <ng-container *ngIf="action.icon">
          <i *ngIf="action.icon.value.startsWith('feather-')" class="feather icon-{{ action.icon.value.replace('feather-', '') }} {{
              action.icon.class
            }}"></i>
          <i *ngIf="action.icon.value.startsWith('custom-')" class="custom-icon-{{ action.icon.value.replace('custom-', '') }} {{
              action.icon.class
            }}"></i>
        </ng-container>
        <span class="text-{{ action.label.class }}">
          {{ action.label.value }}
        </span>
      </a>
    </div>
  </div>
</div>